import { schema, normalize } from 'normalizr';

export const entity = 'vendorReturnResetItemTax';
export const endpoints = {
  reset: ({ vendorReturnID, itemID, payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}/reset-tax`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnResetItemID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);
